import { render, staticRenderFns } from "./SourcesCopyToSelect.vue?vue&type=template&id=065e7be0&scoped=true"
import script from "./SourcesCopyToSelect.vue?vue&type=script&lang=js"
export * from "./SourcesCopyToSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065e7be0",
  null
  
)

export default component.exports